import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Self-heal: stale SW cache after a redeploy makes lazy chunks 404 -> blank screen.
// Detect chunk load failures, wipe caches + SW, and reload once.
const recoverFromStaleCache = async () => {
  if (sessionStorage.getItem('pharmx_cache_recovered')) return;
  sessionStorage.setItem('pharmx_cache_recovered', '1');
  try {
    if ('caches' in window) {
      const names = await caches.keys();
      await Promise.all(names.map((n) => caches.delete(n)));
    }
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
  } catch {}
  window.location.reload();
};
const isChunkError = (msg) => /Loading chunk|ChunkLoadError|dynamically imported module|Importing a module script failed/i.test(msg || '');
window.addEventListener('error', (e) => { if (isChunkError(e?.message)) recoverFromStaleCache(); });
window.addEventListener('unhandledrejection', (e) => { if (isChunkError(e?.reason?.message || String(e?.reason || ''))) recoverFromStaleCache(); });

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        // SW registered
        // Force update check immediately
        registration.update();
        // When a new SW is found, activate it immediately
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'activated') {
              window.location.reload();
            }
          });
        });
      })
      .catch((error) => {
        // SW registration failed
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
